import React from "react";
// Limitless imports
import { fetchPlatformResources } from "@limitless/common/apis/resource-api";
import { useNotificationContext, useTranslation } from "@limitless/common/hooks";
import { useExpertOnboardingContext } from "./ExpertOnboardingContext";
import { useExpertOnboardingContentHook } from "./ExpertOnboardingContentHook";
import { useExpertOnboardingOptInContentHook } from "./ExpertOnboardingOptInContentHook";
const INITIAL_STATE = {
  loading: true,
  template: "",
  headerAndCtaSections: [],
  tabSections: []
};
export const useExpertOnboardingBrandLearningContentHook = (initalFetchCall = true) => {
  const [onboardingBrandLearningContent, setOnboardingBrandLearningContent] = React.useState(INITIAL_STATE);
  const {
    addFailureNotification
  } = useNotificationContext();
  const {
    defaultResourceRequest
  } = useExpertOnboardingContentHook();
  const {
    sectionFormation
  } = useExpertOnboardingOptInContentHook();
  const {
    optInGroup
  } = useExpertOnboardingContext();
  const {
    t = msg => msg
  } = useTranslation();
  React.useEffect(() => {
    if (optInGroup && initalFetchCall) {
      fetchBrandLearningContent(optInGroup);
    }
  }, [optInGroup]);
  const fetchBrandLearningContent = groupProps => {
    const {
      brandLearningPageEnabled
    } = groupProps;
    if (brandLearningPageEnabled) {
      const resource = defaultResourceRequest(groupProps, "brandLearning.json");
      setOnboardingBrandLearningContent({
        ...INITIAL_STATE,
        loading: true
      });
      fetchPlatformResources(resource, res => {
        var _res$0$content$conten, _res$, _res$$content;
        const {
          template,
          headerAndCtaSections,
          tabSections
        } = (_res$0$content$conten = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$content = _res$.content) === null || _res$$content === void 0 ? void 0 : _res$$content.content) !== null && _res$0$content$conten !== void 0 ? _res$0$content$conten : INITIAL_STATE;
        if (template !== "") {
          sectionFormation("brandLearning.json", {
            headerAndCtaSections,
            tabSections
          }, response => {
            const {
              headerAndCtaSections,
              tabSections
            } = response !== null && response !== void 0 ? response : INITIAL_STATE;
            setOnboardingBrandLearningContent({
              ...INITIAL_STATE,
              loading: false,
              template,
              headerAndCtaSections,
              tabSections
            });
          });
        } else {
          setOnboardingBrandLearningContent(INITIAL_STATE);
          addFailureNotification(t("Onboarding Brand Learning page contents missing, please contact Limitless support."));
        }
      }, () => {
        setOnboardingBrandLearningContent(INITIAL_STATE);
        addFailureNotification(t("Onboarding Brand Learning page contents missing, please contact Limitless support."));
      });
    }
  };
  return {
    onboardingBrandLearningContent,
    fetchBrandLearningContent
  };
};